import React, { useState } from 'react';

import ModalContainer from '@components/modals/ModalContainer';

const AddNewSalesContractModal = ({
	setShowAddNewSalesContract,
	onSubmitNewSalesContract,
	salesContructSearchValue
}) => {
	const [newSalesContractValue, setNewSalesContractValue] = useState(salesContructSearchValue);
	const [error, setError] = useState({});

	const validateForm = () => {
		let cloneError = {};
		if (!newSalesContractValue) {
			cloneError.newSalesContractValue = 'Sales Contact is required';
		}

		setError(cloneError);
		return Object.keys(cloneError).filter((key) => cloneError[key] !== undefined).length > 0;
	};
	const onSubmit = () => {
		if (!validateForm()) {
			onSubmitNewSalesContract(null, null, null, newSalesContractValue, (errorState) => {
				if (!errorState) {
					setShowAddNewSalesContract(false);
				}
			});
		}
	};

	return (
		<>
			<ModalContainer
				onCloseModal={() => setShowAddNewSalesContract(false)}
				className="new-sales-contract-modal"
			>
				<div className="common-popup shadow-24dp">
					<div className="common-popup-header d-flex justify-content-between">
						<div className="popup-tilte">
							<h3 className="semibold-16 mb-0">Add New Sales Contact</h3>
						</div>
						<div className="close-btn" onClick={() => setShowAddNewSalesContract(false)}>
							<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt="close" />
						</div>
					</div>
					<div className="common-popup-body">
						<div className="form-group">
							<label>New Sales Contact</label>
							<input
								type="text"
								value={newSalesContractValue}
								onChange={(e) => setNewSalesContractValue(e.target.value)}
							/>
							{error.newSalesContractValue && (
								<p className="error">{error.newSalesContractValue}</p>
							)}
						</div>
					</div>
					<div className="modal-footer text-right">
						<button
							className="button gray-outline size32"
							onClick={() => setShowAddNewSalesContract(false)}
						>
							<span>Cancel</span>
						</button>
						<button className="button size32 ml-2" onClick={onSubmit}>
							Submit
						</button>
					</div>
				</div>
			</ModalContainer>
		</>
	);
};

export default AddNewSalesContractModal;
